import styled from 'styled-components';
import {StyledProps} from './typings';
import pxToRem from '../../theme/helpers/pxToRem';
import typography from '../../theme/typography';
import colors from '../../theme/constants/colors';
import zIndex from '@/theme/constants/zIndex';

const tooltipPosition = (position, offset) => {
  switch (position) {
    case 'top':
      return `
      transform: translate3d(${offset}px, 10px, 0);
      bottom: calc(100% + 10px);
      &::before {
        content: '';
        width: 0;
        height: 0;
        border-bottom: none;
        border-top: 5px solid ${colors.darkBlue100};
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        position: absolute;
        bottom: -5px;
        right: 0;
        left: 0;
        margin: 0 auto;
        transform: translateX(calc(${offset}px * -1));
      }`;
    case 'right':
      return `
      transform: translate3d(-10px, ${offset}px, 0);
      left: 0;
      margin-left: calc(100% + 10px);
      &::before {
        content: '';
        width: 0;
        height: 0;
        border-left: none;
        border-bottom: 7px solid transparent;
        border-top: 7px solid transparent;
        border-right: 5px solid ${colors.darkBlue100};
        position: absolute;
        left: -5px;
        top: 0;
        bottom: 0;
        margin: auto 0;
        transform: translateY(calc(${offset}px * -1));
      }`;
    case 'bottom':
      return `
      transform: translate3d(${offset}px, -10px, 0);
      top: calc(100% + 10px);
      &::before {
        content: '';
        width: 0;
        height: 0;
        border-top: none;
        border-bottom: 5px solid ${colors.darkBlue100};
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        position: absolute;
        top: -5px;
        right: 0;
        left: 0;
        margin: 0 auto;
        transform: translateX(calc(${offset}px * -1));
      }`;
    case 'left':
      return `
      transform: translate3d(10px, ${offset}px, 0);
      right: 0;
      margin-right: calc(100% + 10px);
      &::before {
        content: '';
        width: 0;
        height: 0;
        border-right: none;
        border-bottom: 7px solid transparent;
        border-top: 7px solid transparent;
        border-left: 5px solid ${colors.darkBlue100};
        position: absolute;
        right: -5px;
        top: 0;
        bottom: 0;
        margin: auto 0;
        transform: translateY(calc(${offset}px * -1));
      }`;
    default:
      return ``;
  }
};

const xOffset = (position, offset) => {
  if (position === 'top' || position === 'bottom') {
    return offset;
  } else {
    return 0;
  }
};

const yOffset = (position, offset) => {
  if (position === 'left' || position === 'right') {
    return offset;
  } else {
    return 0;
  }
};

export const StyledTooltip = styled.div`
  position: absolute;
  padding: ${pxToRem(14)} ${pxToRem(18)};
  ${typography.Body2}
  color: ${colors.white};
  max-width: 270px;
  width: max-content;
  background: ${colors.darkBlue100};
  border-radius: 4px;
  pointer-events: none;
  transition: all 0.2s ease-in;
  opacity: 0;
  z-index: ${zIndex.tooltip};
`;

export const StyledTooltipContainer = styled.span<StyledProps>`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  ${StyledTooltip} {
    ${(props) => tooltipPosition(props.$position, props.$offsetBy)}
  }

  &:hover ${StyledTooltip}, &:focus ${StyledTooltip} {
    opacity: 1;
    ${(props) =>
      `transform: translate3d(${xOffset(props.$position, props.$offsetBy)}px, ${yOffset(
        props.$position,
        props.$offsetBy,
      )}px, 0);`}
  }
`;
